import axios from "axios";
import { message } from "antd";
import { PERMISOS_AUTORIZABLES } from "./autorizaciones";
import dineroDisabledMask from "../Components/dineroDisabledMask";

// Intenta aprobar una orden de compra recién guardada. Si el usuario puede
// (permiso + monto), la aprueba directo; si no, manda sola una solicitud
// remota a los autorizadores configurados (autorización "silenciosa", sin
// modal ni PIN)
const intentarAprobarOrdenDeCompra = async ({ ordenId, empresaId, headersToken, folio, monto }) => {
  try {
    const res = await axios.post(
      "ordenesdecompra/aprobarOrden",
      { ordenId, empresaId },
      { headers: headersToken }
    );
    if (res.data.success === 2) {
      message.success("Orden de compra aprobada");
      return { aprobada: true };
    }
    if (res.data.success === 1) {
      message.info(res.data.message);
      return { aprobada: true };
    }
    message.error(res.data.message || "No se pudo aprobar la orden");
    return { aprobada: false };
  } catch (error) {
    if (error?.response?.data?.codigo !== "AUTORIZACION_REQUERIDA") {
      message.error(error?.response?.data?.message || "No se pudo aprobar la orden");
      return { aprobada: false };
    }
  }

  // No puede aprobar por sí mismo: solicitud automática a los autorizadores.
  try {
    const res = await axios.post(
      "/autorizaciones/crearSolicitud",
      {
        empresaId,
        permisoId: PERMISOS_AUTORIZABLES.aprobarOrdenCompra.permisoId,
        contexto: {
          modulo: "ORDEN_COMPRA",
          campo: "aprobarOrdenCompra",
          documentoId: ordenId,
          folio: String(folio ?? ""),
          monto,
          descripcion: `Aprobar orden de compra ${folio ?? ""} por ${dineroDisabledMask(monto || 0)}`,
        },
      },
      { headers: headersToken }
    );
    if (res.data.success === 2) {
      message.info(
        "No tienes permiso para aprobar esta orden: se envió una solicitud a los autorizadores configurados."
      );
    }
    return { aprobada: false, solicitudEnviada: true };
  } catch (error) {
    message.error(
      error?.response?.data?.mensaje || "No se pudo enviar la solicitud de autorización"
    );
    return { aprobada: false, solicitudEnviada: false };
  }
};

export default intentarAprobarOrdenDeCompra;
